import React from "react";
import { BiChevronRight } from "react-icons/bi";
import Link from "next/link";
import { IProduct } from "@/lib/interface";
import ImageWithFallback from "../common/next/NextImage";
import { getImageUrl } from "@/lib/utils";

const ProductCard: React.FC<IProduct> = (props) => {
  const {
    Title,
    Slug,
    BriefDescription,
    FeatureImage,
    DescriptionImage,
    ProductID,
    variant,
    country,
  } = props;

  // console.log('country',country)

  if (variant === "small")
    return (
      <Link href={`/products/${Slug}${country ? "/" + country : ""}`}>
        <div className="w-[50%] h-20 mx-auto relative">
          <ImageWithFallback
            src={
              getImageUrl(DescriptionImage || FeatureImage, "products") || ""
            }
            alt={Title}
            fill={true}
            className="object-contain"
          />
        </div>
        <p className="text-center text-secondary-dark text-xs font-semibold">
          {Title}
        </p>
      </Link>
    );

  return (
    <Link href={`/products/${Slug}${country ? "/" + country : ""}`}>
      <div
        className="shadow p-5  bg-white text-center relative before:absolute before:bottom-0 before:left-0
       before:w-0 before:h-1 hover:before:w-full before:bg-orange-main customtransition flex flex-col appear"
      >
        <div className="h-[300px] w-full relative">
          <ImageWithFallback
            src={
              getImageUrl(DescriptionImage || FeatureImage, "products") || ""
            }
            alt={Title || ""}
            fill={true}
            className="object-contain"
          />
        </div>

        <h4 className="text-secondary-veryDark text-md mb-2 mt-2 font-bold md:h-[10vh] pro_title">
          {Title}
        </h4>

        <p className="leading-6 text-secondary-dark line-clamp-3 text-sm  lg:h-[5vh] xl:h-[12vh] md:h-[7vh] pro-desc">
          {BriefDescription}
        </p>
        <div className=" group overflow-y-hidden    mt-2 mx-auto bg-white py-2 px-6 border  font-semibold rounded-full flex items-center relative  before:absolute before:bottom-0 before:left-0 before:bg-orange-main before:translate-y-12 hover:before:translate-y-0 before:transition-all before:w-full before:h-full before:rounded-full">
          <p className="relative flex items-center group-hover:text-white text-sm">
            Read More <BiChevronRight className="text-xl" />
          </p>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
